import script from "./DonorRecognitionAndBenefitStructureView.vue?vue&type=script&setup=true&lang=js"
export * from "./DonorRecognitionAndBenefitStructureView.vue?vue&type=script&setup=true&lang=js"

import "./DonorRecognitionAndBenefitStructureView.vue?vue&type=style&index=0&id=cc149b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc149b8a"]])

export default __exports__